import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";
import { toast } from "sonner";

export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const run = async () => {
            const hash = window.location.hash || "";
            const m = hash.match(/session_id=([^&]+)/);
            if (!m) {
                nav("/");
                return;
            }
            const session_id = decodeURIComponent(m[1]);
            try {
                const { data } = await api.post("/auth/google/session", {
                    session_id,
                    waiver_accepted: sessionStorage.getItem("sd_waiver_accepted") === "true",
                });
                setUser(data.user);
                sessionStorage.removeItem("sd_waiver_accepted");
                // Remove hash
                window.history.replaceState(null, "", window.location.pathname);
                if (data.user.profile_complete) nav("/discover");
                else nav("/onboarding");
            } catch (e) {
                toast.error("Google sign-in failed");
                nav("/login");
            }
        };
        run();
    }, [nav, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="animate-pulse">
                <Logo size="lg" />
                <p className="text-center mt-4 text-xs uppercase tracking-widest text-white/50">Signing you in…</p>
            </div>
        </div>
    );
}
